/**
 * Memorial Keepsakes helpers — plan gating for physical product requests.
 */

import { KEEPSAKE_IMAGE_SOURCES } from './memorialPhotoLinkBuilder';

/** True when user has a paid archive plan (not free). Unknown plan in dev → treat as paid for testing. */
export function isPaidArchiveMember(user) {
  const plan = user?.plan_type;
  if (!plan) return true;
  return plan !== 'free';
}

/** Keepsake preview is always allowed in V1. */
export function canPreviewMemorialKeepsake() {
  return true;
}

/** Save keepsake request requires paid archive plan when plan is known. */
export function canRequestMemorialKeepsake(user) {
  const plan = user?.plan_type;
  if (!plan) return true;
  return plan !== 'free';
}

/** Temporary browser-only upload — preview OK, save blocked until persisted to storage. */
export function hasTemporaryKeepsakeUpload(builder) {
  if (!builder) return false;
  if (builder.imageSource === KEEPSAKE_IMAGE_SOURCES.upload) {
    if (builder.uploadedKeepsake?.uploaded_image_key || builder.uploadedKeepsake?.uploaded_image_url) {
      return false;
    }
    if (builder.customImageUrl?.startsWith('blob:')) return true;
    return !builder.uploadedKeepsake;
  }
  return false;
}

/** Whether the current builder selection can be saved as a product request. */
export function canSaveMemorialProductRequest(user, builder) {
  if (!canRequestMemorialKeepsake(user)) return false;
  return !hasTemporaryKeepsakeUpload(builder);
}
